import { Component, type ReactNode } from 'react';
import { reportError } from '@/lib/analytics';
import { Mascot } from './Mascot';

/** Непередбачена помилка інтерфейсу → журнал помилок + зрозумілий екран замість білої сторінки. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: unknown, info: { componentStack?: string | null }) { reportError('react', error, { stack: info.componentStack?.slice(0, 800) }); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="grid min-h-dvh place-items-center p-6">
        <div className="card flex max-w-md flex-col items-center gap-4 text-center">
          <Mascot pose="think" className="h-36 w-auto" />
          <h1 className="text-2xl font-black">Ой, щось зламалося</h1>
          <p className="font-semibold text-ink-muted">Твій прогрес збережено на сервері. Онови сторінку й продовжуй.</p>
          <button className="btn" onClick={() => window.location.reload()}>Оновити сторінку</button>
        </div>
      </div>
    );
  }
}
